import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button } from 'react-bootstrap';

function ScanPointsHelpModal(props) {
    const { t } = useTranslation();

    let title;
    let text;

    if (props.type === 'faq') {
        title = t('instructions.scan_points.faq');
        text = t('');
    } else {
        title = t('instructions.scan_points.how_to_read_scans');
        text = t('instructions.scan_points.scan_reading_instructions_text');
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
                {title}
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.type === 'faq' ?
                    <>
                        <p><strong>{t('instructions.scan_points.faq_question1')}</strong></p>
                        <p>{t('instructions.scan_points.faq_answer1')}</p>
                    </>
                :
                    <>
                        <p>{t('instructions.scan_points.eventos_contact_text')}</p>

                        <p><a href="https://contact.eventos.fi/" target="_blank" rel="noopener noreferrer">https://contact.eventos.fi/</a></p>

                        {text}
                    </>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" variant="default" onClick={props.onHide}>{t('general.close')}</Button>
            </Modal.Footer>
        </Modal>
    )
};

export default ScanPointsHelpModal;